import { useQuery } from "@hooks/useQuery";
import { Pagination, TableColumnsType, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, DataTable } from "~/Components";
import ActionDropdown from "~/Modules/ECMS/MAGP/StatusInformation/ActionDropdown";

export const UserTransactions = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const items:any[] = [
    
  ];
  const columns: TableColumnsType = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email ID",
      dataIndex: "emailId",
      key: "emailId",
    },
    {
      title: "Card Type",
      dataIndex: "cardType",
      key: "cardType",
    },
    {
      title: "Epic Number",
      dataIndex: "epicNumber",
      key: "epicNumber",
    },
    {
      title: "Total Transactions",
      dataIndex: "totalTransactions",
      key: "totalTransactions",
    },
  ];

  return (
    <ContentWrapper title={"User Transactions"} showBack>
       <>
          <DataTable
            tabOffset={60}
            columns={columns}
            className="table-clickable"
            tableData={
              []
            }
            // isLoading={isLoading}
            exportFileName="CONTRACT"
            isPagination={true}
            recordsPerPage={10}
            multiSelect={false}
            hideExport={true}
            isServerSearchApi={true}
            searchPlaceholderText={"Search"}
          />
        </>
    </ContentWrapper>
  );
};
